export default "__VITE_ASSET__5abb854f__"